import React from 'react';
import { func } from 'prop-types';
import { reduceToSingleArray } from '../helpers';
import { ListContentContainer } from '../LuContent.styles';
import Flex from '../../../atoms/Flex';
import LuContentButton from '../../../atoms/Button';
import LuContentItem from '../LuContentItem';
import { useLuContentContext } from '../LuContentContext';

const HorizontalContent = ({
  onItemClick,
  onLoadMoreClick
}) => {
  const {
    data,
    linkToMoreContent,
    hide
  } = useLuContentContext();
  const items = reduceToSingleArray(data);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListContentContainer, {
    itemsSize: items.length
  }, items.map(item => /*#__PURE__*/React.createElement(LuContentItem, {
    key: item.id,
    vertical: true,
    data: item,
    onItemClick: onItemClick,
    itemsSize: items.length
  }))), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    p: 3
  }, /*#__PURE__*/React.createElement(LuContentButton, {
    as: "a",
    variation: "outline",
    color: "luContent",
    centered: true,
    uppercase: false,
    href: linkToMoreContent,
    onClick: onLoadMoreClick,
    hide: hide
  }, "Veja outros conte\xFAdos")));
};

process.env.NODE_ENV !== "production" ? HorizontalContent.propTypes = {
  onItemClick: func,
  onLoadMoreClick: func,
  onPreviewClick: func
} : void 0;
export default HorizontalContent;